import NewGamesSelector from './NewGamesSelector';
import './index.scss';
export default NewGamesSelector;
